import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { Checkmark16Regular } from '@fluentui/react-icons';
import { vt } from '../../theme';

const useStyles = makeStyles({
  title: { margin: '0 0 12px', fontSize: '17px', fontWeight: tokens.fontWeightSemibold, color: vt.fg1 },
  tiers: { listStyleType: 'none', margin: 0, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '14px' },
  tier: {
    display: 'grid',
    gridTemplateColumns: '16px minmax(0, 1fr)',
    columnGap: '12px',
    alignItems: 'start',
    padding: '16px',
    minHeight: '72px',
    boxSizing: 'border-box',
    borderRadius: '8px',
    backgroundColor: vt.surface3,
  },
  todo: { backgroundColor: 'transparent', border: `1px solid ${vt.surface2}` },
  mark: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '16px' },
  done: { color: vt.green },
  live: { width: '8px', height: '8px', borderRadius: '50%', backgroundColor: vt.cyan, boxShadow: `0 0 0 3px ${vt.tintCyan}` },
  ring: { width: '9px', height: '9px', borderRadius: '50%', border: `1.3px solid ${vt.fg4}`, boxSizing: 'border-box' },
  name: { fontSize: '12px', fontWeight: tokens.fontWeightSemibold, color: vt.fg1 },
  nameTodo: { color: vt.fg3 },
  body: { display: 'block', marginTop: '6px', fontSize: '11px', color: vt.fg4 },
});

type TierState = 'done' | 'doing' | 'todo';

const TIERS: [string, string, TierState][] = [
  ['Tier 1 — now', 'Any OpenWRT box runs the agent', 'done'],
  ['Tier 2 — next', 'Your own image, claim-code onboarding', 'doing'],
  ['Tier 3 — later', 'Your own board: NRE, compliance, spins', 'todo'],
];

/** Mockup 08's roadmap strip: the hardware ambition, one honest line per tier. */
export function HardwarePath() {
  const s = useStyles();
  return (
    <section aria-label="Hardware path">
      <h2 className={s.title}>Hardware path</h2>
      <ol className={s.tiers}>
        {TIERS.map(([name, body, state]) => (
          <li key={name} className={mergeClasses(s.tier, state === 'todo' && s.todo)} data-state={state}>
            <span className={s.mark} aria-hidden>
              {state === 'done' ? (
                <Checkmark16Regular className={s.done} />
              ) : state === 'doing' ? (
                <span className={s.live} />
              ) : (
                <span className={s.ring} />
              )}
            </span>
            <span>
              <span className={mergeClasses(s.name, state === 'todo' && s.nameTodo)}>{name}</span>
              <span className={s.body}>{body}</span>
            </span>
          </li>
        ))}
      </ol>
    </section>
  );
}
